import { getForecastNumber } from '../IndicatorDetails/IndicatorDetailQuestions/utils';
import { IndicatorDetails } from '../IndicatorDetails/utils';
import { ReportPeriod } from '../SectionPeriod/utils';
import { getSentenceStructure, replaceMadLib } from './IndicatorCardDetails';
import { Indicator, IndicatorSectionKey, IndicatorWithUpdate } from './utils';

interface IndicatorMadLibs {
  unit: string;
  forecastOutcome: string;
  finalOutcome: string;
  outcome: string;
}

export const indicatorMadLibs: { [id: number]: IndicatorMadLibs } = {
  10058: {
    unit: 'influencers',
    forecastOutcome: 'will be activated',
    finalOutcome: 'were activated',
    outcome: 'be activated',
  },
  10013: {
    unit: 'infrastructures',
    forecastOutcome: 'will be developed or enhanced',
    finalOutcome: 'were developed or enhanced',
    outcome: 'be developed or enhanced',
  },
  10106: {
    unit: 'narrative change efforts',
    forecastOutcome: 'will be initiated',
    finalOutcome: 'were initiated',
    outcome: 'be initiated',
  },
  10103: {
    unit: 'organizations',
    forecastOutcome: 'will be created or expanded',
    finalOutcome: 'were created or expanded',
    outcome: 'be created or expanded',
  },
  10027: {
    unit: 'partnerships or collaborations',
    forecastOutcome: 'will be established or expanded',
    finalOutcome: 'were established or expanded',
    outcome: 'be established or expanded',
  },
  10060: {
    unit: 'policies or laws',
    forecastOutcome: 'will be influenced',
    finalOutcome: 'were influenced',
    outcome: 'be influenced',
  },
  10026: {
    unit: 'programs or services',
    forecastOutcome: 'will be created or enhanced',
    finalOutcome: 'were created or enhanced',
    outcome: 'be created or enhanced',
  },
  10059: {
    unit: 'program resources',
    forecastOutcome: 'will be developed or enhanced',
    finalOutcome: 'were developed or enhanced',
    outcome: 'be developed or enhanced',
  },
  10101: {
    unit: 'staff or implementers',
    forecastOutcome: 'will be hired or trained',
    finalOutcome: 'were hired or trained',
    outcome: 'be hired or trained',
  },
  10104: {
    unit: 'trainings or events',
    forecastOutcome: 'will be held',
    finalOutcome: 'were held',
    outcome: 'be held',
  },
  10102: {
    unit: 'volunteers',
    forecastOutcome: 'will be recruited or engaged',
    finalOutcome: 'were recruited or engaged',
    outcome: 'be recruited or engaged',
  },
  10107: {
    unit: 'network building efforts',
    forecastOutcome: 'will be initiated',
    finalOutcome: 'were initiated',
    outcome: 'be initiated',
  },
  10032: {
    unit: 'people',
    forecastOutcome: 'will be reached',
    finalOutcome: 'were reached',
    outcome: 'be reached',
  },
  10023: {
    unit: 'acres of land',
    forecastOutcome: 'will be reached',
    finalOutcome: 'were reached',
    outcome: 'be reached',
  },
  10064: {
    unit: 'animals',
    forecastOutcome: 'will be reached',
    finalOutcome: 'were reached',
    outcome: 'be reached',
  },
  10069: {
    unit: 'meals',
    forecastOutcome: 'will be distributed',
    finalOutcome: 'were distributed',
    outcome: 'be distributed',
  },
  10062: {
    unit: 'miles of riverway',
    forecastOutcome: 'will be reached',
    finalOutcome: 'were reached',
    outcome: 'be reached',
  },
  10068: {
    unit: 'pounds of food (lbs.)',
    forecastOutcome: 'will be distributed',
    finalOutcome: 'were distributed',
    outcome: 'be distributed',
  },
  10063: {
    unit: 'square miles of oceans',
    forecastOutcome: 'will be reached',
    finalOutcome: 'were reached',
    outcome: 'be reached',
  },
  10088: {
    unit: 'trees',
    forecastOutcome: 'will be planted',
    finalOutcome: 'were planted',
    outcome: 'be planted',
  },
  10073: {
    unit: 'people',
    forecastOutcome: 'will gain skills, knowledge, or motivation',
    finalOutcome: 'gained skills, knowledge, or motivation',
    outcome: 'gain skills, knowledge, or motivation',
  },
  10002: {
    unit: 'people',
    forecastOutcome: 'will improve technology skills',
    finalOutcome: 'improved technology skills',
    outcome: 'improve technology skills',
  },
  10003: {
    unit: 'people',
    forecastOutcome: 'will improve math skills',
    finalOutcome: 'improved math skills',
    outcome: 'improve math skills',
  },
  10004: {
    unit: 'people',
    forecastOutcome: 'will improve reading skills',
    finalOutcome: 'improved reading skills',
    outcome: 'improve reading skills',
  },
  10001: {
    unit: 'people',
    forecastOutcome: 'will gain safe water access',
    finalOutcome: 'gained safe water access',
    outcome: 'gain safe water access',
  },
  10074: {
    unit: 'people',
    forecastOutcome: 'will take action or change behaviors',
    finalOutcome: 'took action or changed behaviors',
    outcome: 'take action or change behaviors',
  },
  10000: {
    unit: 'dollars ($USD)',
    forecastOutcome: 'will be raised',
    finalOutcome: 'were raised',
    outcome: 'be raised',
  },
  10005: {
    unit: 'community leaders',
    forecastOutcome: 'will be activated or strengthened',
    finalOutcome: 'were activated or stregthened',
    outcome: 'be activated or strengthened',
  },
  10006: {
    unit: 'people',
    forecastOutcome:
      'will become artists or increase their interest in practicing the arts',
    finalOutcome:
      'became artists or increased their interest in practicing the arts',
    outcome: 'become artists or increase their interest in practicing the arts',
  },
  10007: {
    unit: 'people',
    forecastOutcome:
      'will expand their practice or increase their commitment to practicing the arts',
    finalOutcome:
      'expanded their practice or increased their commitment to practicing the arts',
    outcome:
      'expand their practice or increase their commitment to practicing the arts',
  },
  10008: {
    unit: 'people',
    forecastOutcome: 'will become an advocate or patron',
    finalOutcome: 'became an advocate or patron',
    outcome: 'become an advocate or patron',
  },
  10009: {
    unit: 'people',
    forecastOutcome: 'will experience reduced commute times',
    finalOutcome: 'experienced reduced commute times',
    outcome: 'experience reduced commute times',
  },
  10010: {
    unit: 'people',
    forecastOutcome: 'will gain social networks and supports',
    finalOutcome: 'gained social networks and supports',
    outcome: 'gain social networks and supports',
  },
  10011: {
    unit: 'people',
    forecastOutcome: 'will read at grade level',
    finalOutcome: 'read at grade level',
    outcome: 'read at grade level',
  },
  10012: {
    unit: 'people',
    forecastOutcome: 'will progress to the next grade on time',
    finalOutcome: 'progressed to the next grade on time',
    outcome: 'progress to the next grade on time',
  },
  10014: {
    unit: 'businesses',
    forecastOutcome: 'will be created, saved, or strengthened',
    finalOutcome: 'were created, saved, or stregthened',
    outcome: 'be created, saved, or strengthened',
  },
  10015: {
    unit: 'people',
    forecastOutcome: 'will gain welcoming and affirming environments',
    finalOutcome: 'gained welcoming and affirming environments',
    outcome: 'gain welcoming and affirming environments',
  },
  10016: {
    unit: 'people',
    forecastOutcome: 'will increase agriculture yields or reduce waste',
    finalOutcome: 'increased agriculture yields or reduced waste',
    outcome: 'increase agriculture yields or reduce waste',
  },
  10017: {
    unit: 'dollars ($USD)',
    forecastOutcome: 'will be gained in increased income or reduced waste',
    finalOutcome: 'were gained in increased income or reduced waste',
    outcome: 'be gained in increased income or reduced waste',
  },
  10018: {
    unit: 'pounds of food (lbs.)',
    forecastOutcome: 'will be gained from increased yields or reduced waste',
    finalOutcome: 'were gained from increased yields or reduced waste',
    outcome: 'be gained from increased yields or reduced waste',
  },
  10019: {
    unit: 'pounds of materials (lbs.)',
    forecastOutcome: 'will be recycled',
    finalOutcome: 'were recycled',
    outcome: 'be recycled',
  },
  10020: {
    unit: 'people',
    forecastOutcome: 'will protect or improve their health',
    finalOutcome: 'protected or improved their health',
    outcome: 'protect or improve their health',
  },
  10021: {
    unit: 'people',
    forecastOutcome: 'will improve their mental health',
    finalOutcome: 'improved their mental health',
    outcome: 'improve their mental health',
  },
  10022: {
    unit: 'people',
    forecastOutcome:
      'will benefit from the protection or restoration of natural resources',
    finalOutcome:
      'benefitted from the protection or restoration of natural resources',
    outcome: 'benefit from the protection or restoration of natural resources',
  },
  10024: {
    unit: 'people',
    forecastOutcome: 'will experience increased safety',
    finalOutcome: 'experienced increased safety',
    outcome: 'experience increased safety',
  },
  10025: {
    unit: 'people',
    forecastOutcome: 'will gain a thriving wage job',
    finalOutcome: 'gained a thriving wage job',
    outcome: 'gain a thriving wage job',
  },
  10028: {
    unit: 'people',
    forecastOutcome: 'will graduate high school',
    finalOutcome: 'graduated high school',
    outcome: 'graduate high school',
  },
  10029: {
    unit: 'people',
    forecastOutcome: 'will earn a post-secondary degree or credential',
    finalOutcome: 'earned a post-secondary degree or credential',
    outcome: 'earn a post-secondary degree or credential',
  },
  10030: {
    unit: 'animals',
    forecastOutcome: 'will be protected or experience improved well-being',
    finalOutcome: 'were protected or experienced improved well-being',
    outcome: 'be protected or experience improved well-being',
  },
  10031: {
    unit: 'people',
    forecastOutcome: 'will gain fulfillment or enjoyment',
    finalOutcome: 'gained fulfillment or enjoyment',
    outcome: 'gain fulfillment or enjoyment',
  },
  10033: {
    unit: 'people',
    forecastOutcome: 'will improve professional productivity or effectiveness',
    finalOutcome: 'improved professional productivity or effectiveness',
    outcome: 'improve professional productivity or effectiveness',
  },
  10034: {
    unit: 'people',
    forecastOutcome: 'will improve their behavior',
    finalOutcome: 'improved their behavior',
    outcome: 'improve their behavior',
  },
  10035: {
    unit: 'people',
    forecastOutcome: 'will improve their income',
    finalOutcome: 'improved their income',
    outcome: 'improve their income',
  },
  10036: {
    unit: 'people',
    forecastOutcome: 'will avoid relapse',
    finalOutcome: 'avoided relapse',
    outcome: 'avoid relapse',
  },
  10037: {
    unit: 'people',
    forecastOutcome: 'will reduce costs or lost income',
    finalOutcome: 'reduced costs or lost income',
    outcome: 'reduce costs or lost income',
  },
  10038: {
    unit: 'discoveries or resources',
    forecastOutcome: 'will be generated',
    finalOutcome: 'were generated',
    outcome: 'be generated',
  },
  10039: {
    unit: 'ecosystems',
    forecastOutcome: 'will be protected or restored',
    finalOutcome: 'were protected or restored',
    outcome: 'be protected or restored',
  },
  10040: {
    unit: 'locations',
    forecastOutcome: 'will achieve air quality targets',
    finalOutcome: 'achieved air quality targets',
    outcome: 'achieve air quality targets',
  },
  10041: {
    unit: 'people',
    forecastOutcome: 'will benefit from new discoveries or resources',
    finalOutcome: 'benefitted from new discoveries or resources',
    outcome: 'benefit from new discoveries or resources',
  },
  10042: {
    unit: 'pounds of pollutants (lbs.) or toxic compounds',
    forecastOutcome: 'will be reduced',
    finalOutcome: 'were reduced',
    outcome: 'be reduced',
  },
  10043: {
    unit: 'species',
    forecastOutcome: 'will be protected or experience improved well-being',
    finalOutcome: 'were protected or experienced improved well-being',
    outcome: 'be protected or experience improved well-being',
  },
  10044: {
    unit: 'people',
    forecastOutcome: 'will access post-secondary education',
    finalOutcome: 'accessed post-secondary education',
    outcome: 'access post-secondary education',
  },
  10045: {
    unit: 'people',
    forecastOutcome: 'will improve their school attendance',
    finalOutcome: 'improved their school attendance',
    outcome: 'improve their school attendance',
  },
  10046: {
    unit: 'people',
    forecastOutcome: 'will achieve or improve their food security',
    finalOutcome: 'achieved or improved their food security',
    outcome: 'achieve or improve their food security',
  },
  // 788: {
  //   unit: 'people',
  //   forecastOutcome: 'will attain, retain, or improve their employment',
  //   finalOutcome: 'attained, retained, or improved their employment',
  //   outcome: 'attain, retain, or improve their employment'
  // },
  // 790: {
  //   unit: 'family members',
  //   forecastOutcome: 'will improve their economic well-being',
  //   finalOutcome: 'improved their economic well-being',
  //   outcome: 'improve their economic well-being'
  // },
  10047: {
    unit: 'people',
    forecastOutcome: 'will save time',
    finalOutcome: 'saved time',
    outcome: 'save time',
  },
  10048: {
    unit: 'pounds of hazardous materials (lbs.)',
    forecastOutcome: 'will be disposed or controlled',
    finalOutcome: 'were disposed or controlled',
    outcome: 'be disposed or controlled',
  },
  10049: {
    unit: 'short tons of materials',
    forecastOutcome: 'will be recycled for new end use',
    finalOutcome: 'were recycled for new end users',
    outcome: 'be recycled for new end use',
  },
  10050: {
    unit: 'dollars ($USD)',
    forecastOutcome: 'will be generated or saved',
    finalOutcome: 'were generated or saved',
    outcome: 'be generated or saved',
  },
  10051: {
    unit: 'acres of land',
    forecastOutcome: 'will be protected or restored',
    finalOutcome: 'were protected or restored',
    outcome: 'be protected or restored',
  },
  10052: {
    unit: 'square miles of oceans',
    forecastOutcome: 'will be protected or restored',
    finalOutcome: 'were protected or restored',
    outcome: 'be protected or restored',
  },
  10053: {
    unit: 'miles of riverways',
    forecastOutcome: 'will be protected or restored',
    finalOutcome: 'were protected or restored',
    outcome: 'be protected or restored',
  },
  10054: {
    unit: 'gallons of water',
    forecastOutcome: 'will be conserved',
    finalOutcome: 'were conserved',
    outcome: 'be conserved',
  },
  10055: {
    unit: 'kilowatthours (kWhs)',
    forecastOutcome: 'will be generated',
    finalOutcome: 'were generated',
    outcome: 'be generated',
  },
  10056: {
    unit: 'kilowatthours (kWhs)',
    forecastOutcome: 'will be saved',
    finalOutcome: 'were saved',
    outcome: 'be saved',
  },
  10057: {
    unit: 'metric tons of CO2e',
    forecastOutcome: 'will be reduced',
    finalOutcome: 'were reduced',
    outcome: 'be reduced',
  },
  10061: {
    unit: 'people',
    forecastOutcome: 'will gain school readiness',
    finalOutcome: 'gained school readiness',
    outcome: 'gain school readiness',
  },
  10065: {
    unit: 'people',
    forecastOutcome: 'will strengthen their civic engagement',
    finalOutcome: 'strengthened their civic engagement',
    outcome: 'strengthen their civic engagement',
  },
  10066: {
    unit: 'people',
    forecastOutcome: 'will gain financial strength',
    finalOutcome: 'gained financial strength',
    outcome: 'gain financial strength',
  },
  10067: {
    unit: 'people',
    forecastOutcome: 'will avoid injury',
    finalOutcome: 'avoided injury',
    outcome: 'avoid injury',
  },
  // 836: {
  //   unit: 'people',
  //   forecastOutcome: 'will attain, retain, or improve their housing',
  //   finalOutcome: 'attained, retained, or improved their housing',
  //   outcome: 'attain, retain, or improve their housing'
  // },
  10070: {
    unit: 'people',
    forecastOutcome: 'will achieve leadership positions',
    finalOutcome: 'achieved leadership positions',
    outcome: 'achieve leadership positions',
  },
  10071: {
    unit: 'people',
    forecastOutcome: 'will age in place',
    finalOutcome: 'aged in place',
    outcome: 'age in place',
  },
  10072: {
    unit: 'homes',
    forecastOutcome: 'will increase value',
    finalOutcome: 'increased value',
    outcome: 'increase value',
  },
  // 846: {
  //   unit: 'vacant properties',
  //   forecastOutcome: 'will be redeveloped',
  //   finalOutcome: 'were redeveloped',
  //   outcome: 'be redeveloped'
  // },
  10075: {
    unit: 'short tons of materials',
    forecastOutcome: 'will be recovered',
    finalOutcome: 'were recovered',
    outcome: 'be recovered',
  },
  10076: {
    unit: 'people',
    forecastOutcome: 'will improve their social and emotional well-being',
    finalOutcome: 'improved their social and emotional well-being',
    outcome: 'improve their social and emotional well-being',
  },
  10077: {
    unit: 'people',
    forecastOutcome: 'will improve their academic performance',
    finalOutcome: 'improved their academic performance',
    outcome: 'improve their academic performance',
  },
  10078: {
    unit: 'short tons of ocean bound materials',
    forecastOutcome: 'will be recovered',
    finalOutcome: 'were recovered',
    outcome: 'be recovered',
  },
  10079: {
    unit: 'people',
    forecastOutcome: 'will strengthen their connections to faith',
    finalOutcome: 'strengthened their connections to faith',
    outcome: 'strengthen their connections to faith',
  },
  10114: {
    unit: 'people',
    forecastOutcome: 'will become civic leaders or advocates',
    finalOutcome: 'became civic leaders or advocates',
    outcome: 'become civic leaders or advocates',
  },
  10115: {
    unit: 'people',
    forecastOutcome:
      'will become cultural consumers or increase their commitment',
    finalOutcome: 'became cultural consumers or increase their commitment',
    outcome: 'become cultural consumers or increase their commitment',
  },
  10080: {
    unit: 'people',
    forecastOutcome: 'will experience improved well-being',
    finalOutcome: 'experienced improved well-being',
    outcome: 'experience improved well-being',
  },
  10081: {
    unit: 'people',
    forecastOutcome: 'will avoid conflict or reduce crime, abuse, or violence',
    finalOutcome: 'avoided conflict or reduced crime, abuse, or violence',
    outcome: 'avoid conflict or reduce crime, abuse, or violence',
  },
  10082: {
    unit: 'jobs',
    forecastOutcome: 'will be created or saved',
    finalOutcome: 'were created or saved',
    outcome: 'be created or saved',
  },
  10083: {
    unit: 'people',
    forecastOutcome: 'will avoid recidivism',
    finalOutcome: 'avoided recidivism',
    outcome: 'avoid recidivism',
  },
  10084: {
    unit: 'people',
    forecastOutcome:
      'will experience improved neighborhood satisfaction or quality of life',
    finalOutcome:
      'experienced improved neighborhood satisfaction or quality of life',
    outcome: 'experience improved neighborhood satisfaction or quality of life',
  },
  10085: {
    unit: 'people',
    forecastOutcome: 'will achieve key development milestones',
    finalOutcome: 'achieved key development milestones',
    outcome: 'achieve key development milestones',
  },
  10086: {
    unit: 'people',
    forecastOutcome: 'will vote',
    finalOutcome: 'voted',
    outcome: 'vote',
  },
  10087: {
    unit: 'acres of land',
    forecastOutcome: 'will have improved soil health',
    finalOutcome: 'have improved soil health',
    outcome: 'have improved soil health',
  },
  10089: {
    unit: 'dollars ($USD)',
    forecastOutcome: 'will have increased their value of collected materials',
    finalOutcome: 'have increased value of collected materials',
    outcome: 'have increased their value of collected materials',
  },
  10090: {
    unit: 'dollars ($USD)',
    forecastOutcome: 'will be saved in reduced landfill costs',
    finalOutcome: 'were saved in reduced landfill costs',
    outcome: 'be saved in reduced landfill costs',
  },
  10091: {
    unit: 'businesses or organizations',
    forecastOutcome: 'will be reached',
    finalOutcome: 'were reached',
    outcome: 'be reached',
  },
  10092: {
    unit: 'pounds of materials (lbs.)',
    forecastOutcome: 'will be reduced or removed from supply chains',
    finalOutcome: 'were reduced or removed from supply chains',
    outcome: 'be reduced or removed from supply chains',
  },
  10093: {
    unit: 'people',
    forecastOutcome: 'will experience fewer acts of intolerance',
    finalOutcome: 'experienced fewer acts of intolerance',
    outcome: 'experience fewer acts of intolerance',
  },
  10094: {
    unit: 'people',
    forecastOutcome: 'will gain improved community resources',
    finalOutcome: 'gained improved community resources',
    outcome: 'gain improved community resources',
  },
  10095: {
    unit: 'people',
    forecastOutcome: 'will become advocates of gender equity',
    finalOutcome: 'became advocates of gender equity',
    outcome: 'become advocates of gender equity',
  },
  // 929: {
  //   unit: 'people',
  //   forecastOutcome: 'will gain access to safe water',
  //   finalOutcome: 'gained access to safe water',
  //   outcome: 'gain access to safe water'
  // },
  10096: {
    unit: 'pounds of food (lbs.)',
    forecastOutcome: 'will be recovered, reclaimed, or redirected',
    finalOutcome: 'were recovered, reclaimed, or redirected',
    outcome: 'be recovered, reclaimed, or redirected',
  },
  // 932: {
  //   unit: 'properties',
  //   forecastOutcome: 'will be improved or restored',
  //   finalOutcome: 'were improved or restored',
  //   outcome: 'be improved or restored'
  // },
  10097: {
    unit: 'people',
    forecastOutcome: 'will become homeowners',
    finalOutcome: 'became homeowners',
    outcome: 'become homeowners',
  },
  10098: {
    unit: 'people',
    forecastOutcome:
      'will increase participation in production, income, or household decision-making',
    finalOutcome:
      'increased participation in production, income, or household decision-making',
    outcome:
      'increase participation in production, income, or household decision-making',
  },
  10099: {
    unit: 'people',
    forecastOutcome:
      'will improve control or ownership of resources, assets, and services',
    finalOutcome:
      'improved control or ownership of resources, assets, and services',
    outcome: 'improve control or ownership of resources, assets, and services',
  },
  10100: {
    unit: 'people',
    forecastOutcome: 'will improve land rights or ownerships',
    finalOutcome: 'improved land rights or ownership',
    outcome: 'improve land rights or ownerships',
  },
  // 940: {
  //   unit: 'community or family members',
  //   forecastOutcome: 'will improve their well-being',
  //   finalOutcome: 'improved their well-being',
  //   outcome: 'improve their well-being'
  // },
  10105: {
    unit: 'people',
    forecastOutcome: 'will indirectly benefit',
    finalOutcome: 'indirectly benefitted',
    outcome: 'indirectly benefit',
  },
  // 823: {
  //   unit: 'farmers, landowners, or harvesters',
  //   forecastOutcome: 'will substantially improve their income',
  //   finalOutcome: 'substantially improved their income',
  //   outcome: 'substantially improve their income'
  // },
  10108: {
    unit: 'people',
    forecastOutcome: 'will gain a new job',
    finalOutcome: 'gained a new job',
    outcome: 'gain a new job',
  },
  10109: {
    unit: 'people',
    forecastOutcome: 'will gain long-term housing',
    finalOutcome: 'gained long-term housing',
    outcome: 'gain long-term housing',
  },
  10110: {
    unit: 'people',
    forecastOutcome: 'will gain temporary housing',
    finalOutcome: 'gained temporary housing',
    outcome: 'gain temporary housing',
  },
  10111: {
    unit: 'people',
    forecastOutcome: 'will gain improve their housing',
    finalOutcome: 'gained improve their housing',
    outcome: 'gain improve their housing',
  },
  10112: {
    unit: 'people',
    forecastOutcome: 'will gain retain a job',
    finalOutcome: 'gained retain a job',
    outcome: 'gain retain a job',
  },
  10113: {
    unit: 'people',
    forecastOutcome: 'will gain retain housing',
    finalOutcome: 'gained retain housing',
    outcome: 'gain retain housing',
  },
};

type IndicatorQuestionType =
  | 'DefinitionInitial'
  | 'DefinitionFinal'
  | 'ForecastInitial'
  | 'ForecastFinal'
  | 'MeasurementInitial'
  | 'MeasurementFinal';

const getDefaultForecastSentence = (serviceGoal: string | undefined) => {
  return `How many people do you forecast take action or change behaviors to ${serviceGoal}`;
};

export const getForecastSentence = (
  indicator: Indicator | undefined,
  programName: string | undefined,
  beneficiaryTerm: string | undefined,
  intermediaries: string | undefined,
  isReportPassed: boolean,
  reportPeriod: ReportPeriod,
  serviceGoal: string | undefined,
  serviceType: string | undefined,
  selectedSectionKey: IndicatorSectionKey,
  reachHumanIndicator: IndicatorDetails | undefined,
  learnIndicator: IndicatorDetails | undefined,
  actIndicator: IndicatorDetails | undefined,
): string | JSX.Element | undefined => {
  if (!indicator) {
    return undefined;
  }
  if (
    (selectedSectionKey === 'learn' || selectedSectionKey === 'act') &&
    !reachHumanIndicator
  ) {
    return getDefaultForecastSentence(serviceGoal);
  }
  const sentence = getSentenceStructure(
    indicator,
    beneficiaryTerm,
    intermediaries,
    selectedSectionKey,
    isReportPassed
      ? indicator.finalForecastStart
      : indicator.initialForecastStart,
    isReportPassed ? indicator.finalForecastEnd : indicator.initialForecastEnd,
    serviceType,
  );
  return sentence
    ? replaceMadLib(
        sentence,
        programName,
        beneficiaryTerm,
        intermediaries,
        isReportPassed,
        reportPeriod,
        serviceGoal,
        reachHumanIndicator,
        learnIndicator,
        actIndicator,
        undefined,
        undefined,
        indicator,
      )
    : undefined;
};

export const getMeasurementSentence = (
  indicator: Indicator | undefined,
  programName: string | undefined,
  beneficiaryTerm: string | undefined,
  intermediaries: string | undefined,
  isReportPassed: boolean,
  reportPeriod: ReportPeriod,
  serviceGoal: string | undefined,
  serviceType: string | undefined,
  selectedSectionKey: IndicatorSectionKey,
  forecast: number | string | undefined,
  finalForecast: number | string | undefined,
): string | JSX.Element | undefined => {
  if (
    !indicator ||
    (isReportPassed && !finalForecast) ||
    (!isReportPassed && !forecast)
  ) {
    return undefined;
  }
  const sentence = getSentenceStructure(
    indicator,
    beneficiaryTerm,
    intermediaries,
    selectedSectionKey,
    isReportPassed
      ? indicator.finalMeasurementStart
      : indicator.initialMeasurementStart,
    isReportPassed
      ? indicator.finalMeasurementEnd
      : indicator.finalMeasurementEnd,
    serviceType,
  );
  return sentence
    ? replaceMadLib(
        sentence,
        programName,
        beneficiaryTerm,
        intermediaries,
        isReportPassed,
        reportPeriod,
        serviceGoal,
        undefined,
        undefined,
        undefined,
        forecast,
        finalForecast,
        indicator,
      )
    : undefined;
};

export const getMadLibForIndicator = (
  indicator: Indicator | IndicatorWithUpdate,
): IndicatorMadLibs | undefined => {
  if (!indicator) return undefined;
  if (
    indicator.unit &&
    indicator.outcome &&
    indicator.forecastOutcome &&
    indicator.finalOutcome
  ) {
    return {
      unit: indicator.unit,
      outcome: indicator.outcome,
      forecastOutcome: indicator.forecastOutcome,
      finalOutcome: indicator.finalOutcome,
    };
  }
  return indicatorMadLibs[indicator.id];
};

export const getIndicatorSentence = (
  i: Indicator | IndicatorWithUpdate,
  type: IndicatorQuestionType,
  indicatorName: string,
  selectedSectionKey: IndicatorSectionKey,
  forecast?: number | string,
  beneficiaryTerm?: string,
): string => {
  const indicator = getMadLibForIndicator(i);

  if (!indicator) {
    switch (type) {
      case 'DefinitionFinal':
      case 'DefinitionInitial':
        return `How many ${indicatorName}`;

      case 'ForecastInitial':
      case 'ForecastFinal':
        return `How many ${indicatorName} will be recruited or hired
        into paid or unpaid positions to improve or expand program
        implementation?`;

      case 'MeasurementFinal':
      case 'MeasurementInitial':
        return 'How will you know the final number of hires once your program is complete?';
    }
  }

  const lowerCaseBeneficiaryTerm = beneficiaryTerm?.toLowerCase();
  const unit =
    indicator.unit === 'people' && lowerCaseBeneficiaryTerm
      ? lowerCaseBeneficiaryTerm === 'animals'
        ? 'people'
        : lowerCaseBeneficiaryTerm
      : indicator.unit;

  switch (type) {
    case 'DefinitionInitial':
      return `Define what "${unit} ${indicator.forecastOutcome}" means to your organization.`;

    case 'DefinitionFinal':
      return `Define what "${unit} ${indicator.finalOutcome}" means to your organization.`;

    case 'ForecastInitial':
      return `How many ${unit} ${indicator.forecastOutcome}?`;

    case 'ForecastFinal':
      return `How many ${unit} ${indicator.finalOutcome}?`;

    case 'MeasurementInitial':
      return `How will you know ${getForecastNumber(forecast)} ${unit} ${
        indicator.finalOutcome
      }?`;

    case 'MeasurementFinal':
      return `How do you know ${getForecastNumber(forecast)} ${unit} ${
        indicator.finalOutcome
      }?`;
  }
};
